// extracted by mini-css-extract-plugin
export default {"modal-header":"HideStatsInfo--modal-header--clEVm","modalHeader":"HideStatsInfo--modal-header--clEVm"};